import { render } from "./Xiaofeng.vue?vue&type=template&id=03032a44&scoped=true&ts=true"
import script from "./Xiaofeng.vue?vue&type=script&lang=ts"
export * from "./Xiaofeng.vue?vue&type=script&lang=ts"

import "./Xiaofeng.vue?vue&type=style&index=0&id=03032a44&lang=scss&scoped=true"

import exportComponent from "D:\\work\\h5\\2024sclh\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03032a44"]])

export default __exports__